import type React from 'react';

interface EmptyApiKeysProps {
  onCreateKey: () => void;
}

export const EmptyApiKeys: React.FC<EmptyApiKeysProps> = ({ onCreateKey }) => (
  <div className="terminal-box border border-dashed border-terminal-orange-dim p-8 flex flex-col items-center justify-center">
    <div className="max-w-md text-center">
      <p className="text-terminal-orange-bright text-lg mb-2">No child API keys yet</p>
      <p className="text-terminal-orange-dim text-sm mb-6">
        Create your first child key to start distributing access to your users.
      </p>
      <button className="terminal-button" onClick={onCreateKey}>
        [ CREATE CHILD KEY ]
      </button>
    </div>
  </div>
);

interface EmptyCreditsProps {
  onAddCredits?: () => void;
}

export const EmptyCredits: React.FC<EmptyCreditsProps> = ({ onAddCredits }) => (
  <div className="terminal-box border border-dashed border-terminal-orange-dim p-8 flex flex-col items-center justify-center">
    <div className="max-w-md text-center">
      <p className="text-terminal-orange-bright text-lg mb-2">Credit balance is empty</p>
      <p className="text-terminal-orange-dim text-sm mb-6">
        Add credits to enable API usage for your child keys.
      </p>
      {onAddCredits && (
        <button className="terminal-button" onClick={onAddCredits}>
          [ ADD CREDITS ]
        </button>
      )}
    </div>
  </div>
);

interface EmptyWebhooksProps {
  onCreateWebhook?: () => void;
}

export const EmptyWebhooks: React.FC<EmptyWebhooksProps> = ({ onCreateWebhook }) => (
  <div className="terminal-box border border-dashed border-terminal-orange-dim p-8 flex flex-col items-center justify-center">
    <div className="max-w-md text-center">
      <p className="text-terminal-orange-bright text-lg mb-2">No webhooks configured</p>
      <p className="text-terminal-orange-dim text-sm mb-6">
        Set up webhooks to get notified when credits run low or keys are rotated.
      </p>
      {onCreateWebhook && (
        <button className="terminal-button" onClick={onCreateWebhook}>
          [ CREATE WEBHOOK ]
        </button>
      )}
    </div>
  </div>
);
